import { Avatar, Fab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';
import classNames from 'classnames';
import React from 'react';

/* */
const styles = (theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  fabSm: {
    height: theme.spacing.unit * 5,
    width: theme.spacing.unit * 5,
  },
  avatar: {
    color: theme.palette.secondary.main,
    background: theme.palette.secondary.contrastText,
    fontSize: '2rem',
    height: theme.spacing.unit * 10,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    width: theme.spacing.unit * 10,
    boxShadow: theme.shadows[2],
  },
  avatarSm: {
    fontSize: '1.6rem',
    height: theme.spacing.unit * 7,
    width: theme.spacing.unit * 7,
  },
});

/* */
class Incrementer extends React.Component {
  static defaultProps = {
    minValue: 0,
    maxValue: null,
    thresholdValue: null,
    onLimitReached: () => {},
    onThresholdExceeded: () => {},
  };

  /* */
  componentDidUpdate(prevProps) {
    const { value, maxValue, thresholdValue, onLimitReached, onThresholdExceeded } = this.props;

    if (prevProps.value !== value) {
      if (maxValue != null && value === maxValue) {
        onLimitReached();
      }
      if (thresholdValue != null && value > thresholdValue) {
        onThresholdExceeded();
      }
    }
  }

  /* */
  onDecrease = () => {
    const { value, minValue, onDecrease } = this.props;

    if (value > minValue) {
      onDecrease();
    }
  };

  /* */
  onIncrease = () => {
    const { value, maxValue, onIncrease } = this.props;

    if (maxValue === null || value < maxValue) {
      onIncrease();
    }
  };

  /* */
  render() {
    const { id, size, value, classes, minValue, maxValue } = this.props;

    const disabledMinus = value <= minValue;
    const disabledPlus = maxValue !== null && value >= maxValue;

    return (
      <div id={id} className={classes.container}>
        <Fab
          color='secondary'
          disabled={disabledMinus}
          className={classNames(classes.fab, {
            [classes.fabSm]: size === 'small',
          })}
          onClick={this.onDecrease}
        >
          <RemoveIcon />
        </Fab>
        <Avatar
          className={classNames(classes.avatar, {
            [classes.avatarSm]: size === 'small',
          })}
        >
          {value}
        </Avatar>
        <Fab
          color='secondary'
          disabled={disabledPlus}
          className={classNames(classes.fab, {
            [classes.fabSm]: size === 'small',
          })}
          onClick={this.onIncrease}
        >
          <AddIcon />
        </Fab>
      </div>
    );
  }
}

export default withStyles(styles)(Incrementer);
